import { useContext } from "react";

import AuthContext from "src/contexts/VisitorContext";

const useAuth = () => useContext(AuthContext);

export default useAuth;
